import * as React from 'react';
import { ArtifactAcceptability, PressureResults, PressureTestResults, SpirometryResults, SpirometryTestResults } from '../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import ResultsGroupHeading from '../Shared/ResultsGroupHeading';

export interface QualityAcceptabilityTableProps {
    results: SpirometryResults | PressureResults;
}

interface QualityRowProps {
    title: string;
    artifact: (tr: SpirometryTestResults | PressureTestResults) => ArtifactAcceptability;
}

export const QualityAcceptabilityTable = ({ results }: QualityAcceptabilityTableProps) => {
    const QualityAcceptability = (artifact) => {
        switch (artifact) {
            case ArtifactAcceptability.Undetermined:
                return <i aria-hidden="true" title="Undetermined">-</i>
            case ArtifactAcceptability.Acceptable:
                return <i className="fas fa-check text-success" aria-hidden="true" title="Acceptable"></i>
            case ArtifactAcceptability.Usable:
                return <i className="far fa-circle text-warning" aria-hidden="true" title="Usable"></i>
            case ArtifactAcceptability.NotAcceptable:
                return <i className="fas fa-times text-danger" aria-hidden="true" title="Not Acceptable"></i>
        }
    }

    const QualityRow = ({ title, artifact }: QualityRowProps) => {
        return (
            <tr>
                <td>
                    {title}
                </td>
                {(results.TestResults as any).map((tr) => {
                    return (
                        <td key={`Quality${tr.TestId}`}>
                            {artifact(tr) !== null && artifact(tr) !== undefined ? QualityAcceptability(artifact(tr)) : "-"}
                        </td>
                    );
                })}
                <td></td>
            </tr>
        );
    }
    
    const isSpirometryResults = (results: SpirometryResults | PressureResults): results is SpirometryResults => {
        return (results as SpirometryResults).TestResults[0]?.StartOfTestQuality !== undefined;
    }
    const isPressureResults = (results: SpirometryResults | PressureResults): results is PressureResults => {
        return (results as PressureResults).TestResults[0]?.ShortDurationQuality !== undefined;
    }

    const QualityRows = () => {
        if (isSpirometryResults(results)) {
            return (
                <>
                    <QualityRow title="Start of Test" artifact={(tr) => (tr as SpirometryTestResults).StartOfTestQuality} />
                    <QualityRow title="Flow Plateau" artifact={(tr) => (tr as SpirometryTestResults).FlowPlateauQuality} />
                    <QualityRow title="Cough Free" artifact={(tr) => (tr as SpirometryTestResults).CoughFreeQuality} />
                    <QualityRow title="Test Duration (ATS 2005 only)" artifact={(tr) => (tr as SpirometryTestResults).TestDurationQuality} />
                    <QualityRow title="EOFE" artifact={(tr) => (tr as SpirometryTestResults).EofeQuality} />
                    <QualityRow title="FIVC - FVC" artifact={(tr) => (tr as SpirometryTestResults).FivcFvcQuality} />
                    <QualityRow title="FEV1" artifact={(tr) => (tr as SpirometryTestResults).Fev1Quality} />
                    <QualityRow title="FVC" artifact={(tr) => (tr as SpirometryTestResults).FvcQuality} />
                </>
            )
        } else if (isPressureResults(results)) {
            return <QualityRow title="Short Duration" artifact={(tr) => (tr as PressureTestResults).ShortDurationQuality} />;
        }
    }

    return (
        <>
            <ResultsGroupHeading resultsCount={results.TestResults.length} title="Acceptability" />
            {QualityRows()}
        </>
    );
}

